import styles from "./listing_object.module.css";
import {Image, Carousel, Row, Flex} from "antd";
import {EyeOutlined, MessageOutlined} from "@ant-design/icons";


export default function ListingObject({listingData}) {
    /***
     Listing Object
     id: string
     is_open: bool
     title: string
     description: string
     condition: string
     trade_type: string
     is_pinned: bool
     no_views: int
     listing_image: string (base64)
     ***/
    console.log("here: ", listingData)

    return (
        <div className={styles.listing_container}>
            <Row className={styles.listing_first_row}>
                <Flex gap="middle" horizontal="center" align="center" justify="space-between" style={{width: "100%"}}>
                    <p className={styles.listing_title}>{listingData.title}</p>
                    <p className={styles.no_views}>{listingData.no_views} <EyeOutlined/></p>
                    <p className={styles.send_message}><MessageOutlined /></p>
                </Flex>
            </Row>
            <Row className={styles.listing_second_row}>
                <Flex gap="middle" horizontal="center" align="center" justify="space-between" style={{width: "100%"}}>
                    <p className={styles.listing_category}>{listingData.category.name}</p>
                    <p className={styles.condition}>{listingData.condition}</p>
                    <p className={styles.trade_type}>{listingData.trade_type}</p>
                </Flex>
            </Row>
            <Row>
                <Flex gap="middle" horizontal="center" align="center" justify="center" style={{width: "100%"}}>
                    {listingData.listing_images && <ImageCarousel images={listingData.listing_images}/>}
                </Flex>
            </Row>
            <Row>
                <Flex gap="middle" horizontal="center" align="center" justify="center" style={{width: "100%"}}>
                    <p className={styles.listing_description}>{listingData.description}</p>
                </Flex>
            </Row>
        </div>
    )
}


function ImageCarousel({images}) {
    return (
        <div>
            <Carousel arrows infinite={false} className={styles.image_carousel}>
                {images.map((item, index) => (
                    <Image src={item.includes('base64,') ? item : `data:image/png;base64,${item}`} key={index}/>
                ))}
            </Carousel>
        </div>
    )
}

